import styled from "styled-components";

export default styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  background-color: rgba(255, 255, 255, 0.6);
  pointer-events: none;
  z-index: 10;
  color: black;
  display: flex;
  align-items: center;
  justify-content: center;
`;
